export default {
  title: '元宇宙ID选择',
  txt1: '您通过其他活动获得了新的ID号码，新获得的ID号码将为您保留14天，快选择其中 1 个作为您的专属身份ID吧！',
  btnTxt1: '使用该ID号码',
  card1: '"500万用户的数智世界"活动获得',
  card2: '入驻MyLink元宇宙获得',
  card3: '入驻日期',
  popupTxt1: '确认使用该ID号码？',
  popupTxt2: '您选择的ID号码将作为您在MyLink元宇宙的专属元宇宙ID，您确定继续吗？',
  popupTxt3: '确认',
  popupTxt4: '我再想想',
  isNewLabel:
    'https://mylink.oss-accelerate.aliyuncs.com/mylinkH5/identity/identity/New_acquisition_jian.png',
  isUseLabel:
    'https://mylink.oss-accelerate.aliyuncs.com/mylinkH5/identity/identity/using_jian.png',
  toastTxt1: 'ID号码更换成功',
  toastTxt2: '没有可连接网络，请重试'
}
